import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { SellarImportsRevenueInvoiceCreateResponseType } from "@sellar-io/api-v2/types";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../../hooks/api/v2/apiV2Request";
import { ServerStateKeys } from "../../../../../hooks/api/v2/ServerStateKeys";

export const useSellarImportRevenueInvoiceCreate = (params: { id: number }) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `sellar-imports/finance/payouts/${params.id}/revenue-invoice`,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as SellarImportsRevenueInvoiceCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SellarImportsPayouts,
          params.id,
        ],
      });
    },
  });
};
